module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total applications")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-3"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientsTotal)))])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total devices")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-3"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.devicesTotal)))])])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered"
  }, [_c('div', [_c('p', {
    staticClass: "heading"
  }, [_vm._v("Total cameras")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-3"
  }, [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.camerasTotal)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-5 is-offset-1"
  }, [_c('article', {
    staticClass: "box"
  }, [_c('h5', {
    staticClass: "subtitle is-5"
  }, [_vm._v("Devices by platforms")]), _vm._v(" "), _c('chartjs-pie', {
    attrs: {
      "labels": _vm.deviceLabels,
      "data": _vm.deviceData,
      "backgroundcolor": _vm.deviceBackgroundColor,
      "hoverbackgroundcolor": _vm.deviceHoverBackgroundColor,
      "bind": true,
      "scalesdisplay": false,
      "option": _vm.myoption
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('article', {
    staticClass: "box"
  }, [_c('h5', {
    staticClass: "subtitle is-5"
  }, [_vm._v("Cameras by platforms")]), _vm._v(" "), _c('chartjs-pie', {
    attrs: {
      "labels": _vm.cameraLabels,
      "data": _vm.cameraData,
      "backgroundcolor": _vm.cameraBackgroundColor,
      "hoverbackgroundcolor": _vm.cameraHoverBackgroundColor,
      "bind": true,
      "scalesdisplay": false,
      "option": _vm.myoption
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63410b40"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 346
// module chunks = 1